/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PantryInputs */

const cs_enum_pantry = /** @type {(inputs: Enum_PantryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spižírna`)
};

const en_enum_pantry = /** @type {(inputs: Enum_PantryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantry`)
};

/**
* | output |
* | --- |
* | "Pantry" |
*
* @param {Enum_PantryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_pantry = /** @type {((inputs?: Enum_PantryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PantryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_pantry(inputs)
	return cs_enum_pantry(inputs)
});